
<a href="javascript:void(0)" id="back-to-top" (click)="taptotop()" [ngStyle]="{ 'display' : show ? 'block' : 'none' }">
  <span class="material-symbols-outlined" style="    margin-top: 12px;
  ">
    keyboard_arrow_up
    </span>
</a>
